import { render, staticRenderFns } from "./Wp_tb_select_simple.vue?vue&type=template&id=70defa05&scoped=true&"
import script from "./Wp_tb_select_simple.vue?vue&type=script&lang=js&"
export * from "./Wp_tb_select_simple.vue?vue&type=script&lang=js&"
import style0 from "./Wp_tb_select_simple.vue?vue&type=style&index=0&id=70defa05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70defa05",
  null
  
)

export default component.exports